<template>
  <el-drawer
      @open="init"
      @close="doClose"
      :destroy-on-close="true"
      :close-on-click-modal="true"
      :visible.sync="visible"
      :with-header="false"
      size="970px">

    <el-card class="box-card" shadow="never" style="border-bottom: none;height: 100vh;overflow-y: scroll">
      <div class="drawer-header">
        <h2 class="title">{{ paperName}}</h2>
        <div class="toolbar text-align-reverse" v-if="scheme.flag">
          <el-button size="small" type="primary" @click="personDownload" round><i class="fa fa-download"></i> 批量下载</el-button>
        </div>
      </div>

      <el-divider class="margin-bottom-15 margin-top-10"></el-divider>

      <el-table class="list-table"
                :data="reportList" border
                :stripe="true" style="width: 100%"
                :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                ref="personTable"
                @selection-change="selectPerson">

        <template slot="empty">
          <div class="no-data-user">暂无数据！</div>
        </template>
        <el-table-column type="selection" :selectable="checkState" width="50"></el-table-column>
        <el-table-column label="序号" width="50">
          <template slot-scope="scope">
            <span>{{page.pageSize * (page.pageNo - 1) + scope.$index + 1}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="trueName" label="姓名" min-width="80"></el-table-column>
        <el-table-column prop="unit" label="公司" min-width="170"></el-table-column>
        <el-table-column prop="department" label="部门" min-width="80"></el-table-column>
        <el-table-column label="状态" width="80">
          <template slot-scope="scope">
            <el-tag v-if="scope.row.statue==1" type="" effect="plain" size="small">进行中</el-tag>
            <el-tag v-if="scope.row.statue==2" type="success" effect="plain" size="small">已结束</el-tag>
            <el-tag v-if="scope.row.statue==3" type="danger" effect="plain" size="small">已删除</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="duration" label="时长" width="120" :formatter="formatDuration"></el-table-column>
        <el-table-column label="操作" width="150">
          <template slot-scope="scope">
            <el-button type="text" style="margin-right:4px;" size="small" @click="editRecord(scope.row)"><i class="fa fa-edit"></i> 修改</el-button>
            <el-button type="text" style="margin-right:4px;" size="small"  v-if="scope.row.statue == 2 && paper.flag" @click="skip(scope.row)" ><i class="fa fa-download"></i> 下载</el-button>
            <el-button type="text" style="margin-right:4px;" size="small"  v-if="scope.row.statue == 2 && !paper.flag" @click="skip(scope.row)" ><i class="fa fa-eye"></i> 预览</el-button>
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <page-bar v-model="page" @change="fetchData"></page-bar>


    </el-card>

    <!-- 修改报告的个人信息 -->
    <info-edit :visible="edit_record" :echo="echoUser"  @done="saveRecord"></info-edit>
  </el-drawer>

</template>

<script>
  import {getPersonReport,getSchemeByProjectId} from "@api/manage/company";
  import PageBar from "@components/PageBar";
  import InfoEdit from "./InfoEdit.vue";
  import {deepClone,timeDuration} from "@/utils/index";
  import qs from 'qs'

  export default {
    props: {
      paper: {},
      projectId: null,
      visible: false
    },
    data() {
      return {
        page: {
          pageNo: 1,
          pageSize: 20,
        },
        scheme: { },
        reportList:[],
        paperName:'',
        edit_record:false,
        echoUser:null,
        downId:''
      }
    },
    components: {
      PageBar,InfoEdit
    },
    methods: {
      init(){
        this.paperName = this.paper.title || ''
        this.fetchData()
        this.getSchme()
      },
      getSchme() {
        getSchemeByProjectId(this.projectId).then(res=>{
          this.scheme = res.data.result || {}
        })
      },
      fetchData() {
        let {pageNo,pageSize} = this.page
        getPersonReport(this.projectId,this.paper.id,{pageNo,pageSize}).then(res=>{
          this.page = res.data.result || {}
          this.reportList = res.data.result.records || []
        })
      },
      formatDuration(row, column, val) {
        if(row.statue === 2){
          return timeDuration(row.start * 1000, row.end * 1000)
        }else{
          return '-'
        }
      },
      editRecord (data) {
        this.echoUser = deepClone(data)
        this.edit_record = true
      },
      saveRecord (flag = false) {
        this.edit_record = false
        this.echoUser = null
        if(flag){
          this.fetchData()
        }
      },
      skip(data){
        if( this.scheme.flag == 'fenc'){
          if (data.statue == 2 && this.paper.flag){
            window.open(`/api/wx/fenc/${this.paper.flag}/report/${data.id}`,'target')
          }else if (data.statue == 2 && !this.paper.flag){
            window.open(`/api/wx/fenc/dispatch/${data.id}/${data.paperId}`,'target')
          }
        }else{
          if (data.statue == 2 && this.paper.flag){
            window.open(`/api/wx/${this.paper.flag}/report/${data.id}`,'target')
          }else if (data.statue == 2 && !this.paper.flag){
            window.open(`/api/wx/dispatch/person/${this.projectId}/${data.userId}`,'target')
          }
        }

      },
      personDownload () {
        if (!this.downId) {
          this.$message.warning('请选择人员')
        } else {
          let a = document.createElement('a')
          a.className = 'exportPersonReport'
          a.href = `/api/wx/${this.paper.flag}/report/zip?${this.downId}`
          a.setAttribute('target', '_blank')
          document.querySelector('body').appendChild(a)
          a.click()
          document.querySelector('.exportPersonReport').remove()
        }
      },
      selectPerson () { // 批量下载个人方案
        let list = this.$refs.personTable.selection
        let idList = []
        list.forEach(item => {
          idList.push(item.id)
        })
        this.downId = qs.stringify({ids:idList},{ arrayFormat: 'repeat' })
      },
      checkState (row, index) {
        if(row.statue === 2) {
          return true
        } else {
          return false
        }
      },
      doClose() {
        this.$emit('done', false)
      }
    }
  }
</script>
